import { render, staticRenderFns } from "./FollowMenuItem.vue?vue&type=template&id=795ad918&scoped=true&"
import script from "./FollowMenuItem.vue?vue&type=script&lang=js&"
export * from "./FollowMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795ad918",
  null
  
)

export default component.exports